import { find, get, isEmpty, toLower } from "lodash";
import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { SearchableList, LoaderWrapper } from "../";
import { useDeepEffect, useRequest } from "../../abstracts";
import { addInvestmentType, getInvestmentType } from "../../services";
import { FieldInput } from "../../components";
import { errors, tranformListToDropdownValues } from "../../utils";

const InvestmentTypeDropdown = ({ data, onSelect, value, setData, type }) => {
  const [newInvestmentType, setNewInvestmentType] = useState();
  useDeepEffect(() => {
    if (type) {
      setData(data.filter((_) => _.value !== 1));
    }
  }, [type]);

  const [request, setRequest] = useState({
    method: getInvestmentType,
    stopTrigger: !isEmpty(data),
  });

  const { response, loading } = useRequest(request);

  //  Validation schema
  const schema = Yup.object().shape({
    newInvestmentType: Yup.string()
      .required(errors.masterInvestmentType.required)
      .max(50, errors.masterInvestmentType.length)
      .test(
        "newInvestmentType",
        errors.masterInvestmentType.characters,
        (val) => !checkSplChar(val)
      )
      .test(
        "newInvestmentType",
        errors.masterInvestmentType.alreadyExist,
        (val) => !alreadyExist(val)
      ),
  });
  //    Supporting functions for Validation

  const checkSplChar = (val) => {
    const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (format.test(val) === true) return true;
    else return false;
  };

  const alreadyExist = (val) => {
    const temp = data.map((item) => {
      if (toLower(item.label) === toLower(val)) return true;
      else return false;
    });
    return temp.includes(true);
  };

  const keyDown = (e) => {
    if (e.keyCode == 32) {
      e.preventDefault();
      e.target.value += " ";
    }
  };

  //   Filter function
  useDeepEffect(
    () => {
      if (!loading) {
        if (newInvestmentType) {
          const filteredValue = find(
            response,
            (item) => toLower(item.name) === toLower(newInvestmentType)
          );
          onSelect(
            get(filteredValue, "id", ""),
            get(filteredValue, "name", "")
          );
        }
        setData(tranformListToDropdownValues(response || [], "name", "id"));
      }
    },
    [loading],
    true
  );

  const onFormSubmit = (values) => {
    setNewInvestmentType(values["newInvestmentType"]);
    setRequest({
      ...request,
      stopTrigger: false,
      method: addInvestmentType,
      payload: {
        name: values["newInvestmentType"],
        id: 0,
      },
    });
  };

  return (
    <>
      <LoaderWrapper isLoading={loading} loaderText="">
        <Formik
          initialValues={{ newInvestmentType: "" }}
          validationSchema={schema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={onFormSubmit}
        >
          {({ handleChange, handleSubmit, values }) => {
            return (
              <>
                <div className="dropdside-custom-dropdown">
                  <div>
                    <SearchableList
                      label="Select an Investment type"
                      options={data}
                      onSelect={onSelect}
                      selectedValue={value}
                    />
                  </div>
                  <div className="line-separator"></div>
                  <Form autoComplete="off" onSubmit={handleSubmit}>
                    <Field
                      label="Add a new Investment type :"
                      name={"newInvestmentType"}
                      type="text"
                      value={values["newInvestmentType"]}
                      onChange={handleChange}
                      autoComplete="nope"
                      component={FieldInput}
                      placeholder={"Investment type"}
                      onKeyDown={keyDown}
                    />
                    <Form.Group>
                      <Button type="submit">Add</Button>
                    </Form.Group>
                  </Form>
                </div>
              </>
            );
          }}
        </Formik>
      </LoaderWrapper>
    </>
  );
};

export default InvestmentTypeDropdown;
